<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.terms_and_conditions.form.version')"
            :is-required="true"
            :hint="__('settings.terms_and_conditions.form.version_hint')"
        >
            <DInput
                id="version"
                v-model="form.version"
                :is-valid="isFormFieldValid('version')"
                :invalid-feedback="errors.version"
                maxlength="6"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.terms_and_conditions.form.file')"
            :is-required="true"
            :hint="__('settings.terms_and_conditions.form.file_hint')"
        >
            <DFileInput
                id="file"
                :custom="true"
                :multiple="false"
                :is-valid="isFormFieldValid('file')"
                :invalid-feedback="errors.file"
                @change="addFile"
            />
            <p v-if="form.file">
                {{ form.file.name }}
            </p>
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.terms-and-conditions.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'TermsAndConditionForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                file: null,
                version: this.version?.version ?? null
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        addFile (fileList) {
            this.form.file = fileList[0]
        }
    }
}
</script>
